import React from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogTitle as MuiDialogTitle,
  FormControl,
  styled,
  Slide,
  TextareaAutosize,
} from "@mui/material";
import { useState } from "react";
import toast from "react-hot-toast";
import Label from "@components/shared/form/Label";
import useCreateContact from "@lib/contacts/useCreateContact";

const HeaderContainer = styled(Box)({
  width: "100%",
  paddingTop: "16px",
  paddingLeft: "38px",
  paddingRight: "38px",
});

const Container = styled(Box)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  padding: "0 62px 38px",
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const DialogTitle = styled(MuiDialogTitle)({
  fontSize: "1.5rem",
});

const AddButton = styled(Button)({
  width: "120px",
  maxWidth: "100%",
  marginTop: "30px",
});

const INITIAL_NOTE = {
  content: ""
};

export default function AddContactNoteDialog({ onClose, open, recruiterId }) {
  const [formError, setFormError] = useState("");
  const [note, setNote] = useState(INITIAL_NOTE);
  const create = useCreateContact();

  const handleAdd = () => {
    if (!note.content) {
      setFormError("Please add a note");
      return;
    }

    const data = {
      ...note,
      recruiter_id: recruiterId,
    };

    create.mutate(data, {
      onSuccess: () => {
        toast.success("Note added");
        setNote(INITIAL_NOTE);
        onClose();
      },
      onError: (error) => {
        let errorMessage = "";
        Object.entries(error.response.data.errors).forEach(([, value]) => {
          const messages = value.join("\n");
          errorMessage += `${messages}`;
        });
        setFormError(errorMessage);
      },
    });
  };

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      onClose={onClose}
      open={open}
      keepMounted
      disableAutoFocus={true}
      disableEnforceFocus={true}
      slots={{
        transition: Transition
      }}
    >
      <HeaderContainer>
        <DialogTitle>Add contact note</DialogTitle>
        <Box sx={{ px: 3, pb: 3 }}>
          Add a note to a contact to keep track of your interactions with them.
        </Box>
      </HeaderContainer>
      <Container>
        {formError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {formError}
          </Alert>
        )}
        <FormControl sx={{ width: "100%", mb: 2 }}>
          <Label>Contact note</Label>
          <TextareaAutosize
            id="note"
            variant="outlined"
            autoFocus
            value={note.content}
            minRows={8}
            onChange={(event) => setNote((prev) => ({ ...prev, content: event.target.value }))}
          />
        </FormControl>
        <Box display={"flex"} justifyContent={"flex-end"}>
          <AddButton variant="contained" onClick={handleAdd}>
            Add
          </AddButton>
        </Box>
      </Container>
    </Dialog>
  );
}